// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hleeC","type":"styles_type__2CC_3","choices":"styles_choices__3hKbz"};